define('shared/util/padStart',[],function(){
    return function padStart(str, maximumLength, fillChar) {
        str = str + '';
        if (str.length >= maximumLength) {
            return str;
        }
        var count = 0;
        var numberOfPadChar = maximumLength - str.length;
        while(count < numberOfPadChar) {
            str = fillChar + str;
            count++;
        }

        return str;
    };
});
